import api from '../lib/api';
import { toArray } from '../lib/utils';
import type { User } from '../types/user';

class UserAccountService {
  async getAccounts(): Promise<User[]> {
    const response = await api.get('/users/accounts');
    return toArray(response.data);
  }

  async createAccount(data: Partial<User>): Promise<User> {
    try {
      const response = await api.post('/users/accounts', data);
      return response.data;
    } catch (error: any) {
      // Pass through the raw error response
      throw error.response?.data || error;
    }
  }

  async updateAccount(id: number, data: Partial<User>): Promise<User> {
    try {
      const response = await api.put(`/users/accounts/${id}`, data);
      return response.data;
    } catch (error: any) {
      // Pass through the raw error response
      throw error.response?.data || error;
    }
  }

  async deleteAccount(id: number): Promise<void> {
    try {
      await api.delete(`/users/accounts/${id}`);
    } catch (error: any) {
      // Pass through the raw error response
      throw error.response?.data || error;
    }
  }

  async getAccountById(id: number): Promise<User> {
    const response = await api.get(`/users/accounts/${id}`);
    return response.data;
  }

  async updateAccountStatus(id: number, active: boolean): Promise<void> {
    await api.put(`/users/accounts/${id}/status`, { active });
  }

  async resetTwoFactor(id: number): Promise<void> {
    try {
      await api.post(`/users/accounts/${id}/2fa/reset`);
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }
}

export default new UserAccountService();
